
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

interface Coach {
  id: number;
  name: string;
  specialty: string;
  rating: number;
  reviews: number;
  price: number;
  location: string;
  image: string;
  experience: string;
  description: string;
}

export default function TopCoachesSection() {
  const topCoaches: Coach[] = [
    {
      id: 1,
      name: "Marie Dubois",
      specialty: "Fitness & Musculation",
      rating: 4.9,
      reviews: 127,
      price: 65,
      location: "Paris 15ème",
      experience: "8 ans d'expérience",
      description: "Spécialisée dans la remise en forme et la perte de poids",
      image: "https://public.readdy.ai/ai/img_res/561acc8f73f595fc0845d74da7dece7e.jpg"
    },
    {
      id: 2,
      name: "Thomas Martin",
      specialty: "Yoga & Pilates",
      rating: 4.8,
      reviews: 89,
      price: 55,
      location: "Lyon 6ème",
      experience: "6 ans d'expérience",
      description: "Expert en yoga thérapeutique et relaxation",
      image: "https://readdy.ai/api/search-image?query=Professional%20male%20yoga%20instructor%20in%20peaceful%20meditation%20pose%2C%20experienced%20fitness%20coach%20demonstrating%20yoga%20techniques%2C%20serene%20wellness%20environment%20with%20natural%20lighting%2C%20calm%20and%20focused%20expression%2C%20high-quality%20lifestyle%20photography&width=400&height=400&seq=coach-2&orientation=squarish"
    },
    {
      id: 3,
      name: "Sophie Laurent",
      specialty: "Cardio & HIIT",
      rating: 4.9,
      reviews: 156,
      price: 70,
      location: "Marseille 8ème",
      experience: "10 ans d'expérience",
      description: "Championne de fitness, spécialiste en entraînement intensif",
      image: "https://readdy.ai/api/search-image?query=Dynamic%20female%20fitness%20trainer%20in%20action%20during%20HIIT%20workout%2C%20energetic%20coach%20demonstrating%20cardio%20exercises%2C%20modern%20fitness%20studio%20with%20bright%20lighting%2C%20athletic%20woman%20in%20professional%20sports%20attire%2C%20motivational%20training%20atmosphere&width=400&height=400&seq=coach-3&orientation=squarish"
    },
    {
      id: 4,
      name: "Alexandre Petit",
      specialty: "Musculation & Force",
      rating: 4.7,
      reviews: 98,
      price: 75,
      location: "Toulouse Centre",
      experience: "12 ans d'expérience",
      description: "Ex-athlète professionnel, expert en développement musculaire",
      image: "https://readdy.ai/api/search-image?query=Strong%20male%20fitness%20coach%20demonstrating%20weight%20training%20techniques%2C%20professional%20bodybuilding%20trainer%20in%20modern%20gym%2C%20muscular%20instructor%20showing%20proper%20form%2C%20clean%20fitness%20environment%20with%20professional%20equipment%2C%20motivational%20strength%20training%20atmosphere&width=400&height=400&seq=coach-4&orientation=squarish"
    },
    {
      id: 5,
      name: "Camille Rousseau",
      specialty: "Danse Fitness",
      rating: 4.8,
      reviews: 134,
      price: 60,
      location: "Nice Centre",
      experience: "7 ans d'expérience",
      description: "Danseuse professionnelle, cours de Zumba et danse fitness",
      image: "https://readdy.ai/api/search-image?query=Graceful%20female%20dance%20fitness%20instructor%20in%20dynamic%20movement%2C%20professional%20dancer%20teaching%20fitness%20choreography%2C%20bright%20studio%20with%20mirrors%20and%20natural%20light%2C%20energetic%20and%20joyful%20expression%2C%20high-quality%20dance%20photography&width=400&height=400&seq=coach-5&orientation=squarish"
    },
    {
      id: 6,
      name: "Julien Moreau",
      specialty: "Préparation Physique",
      rating: 4.9,
      reviews: 112,
      price: 80,
      location: "Bordeaux Chartrons",
      experience: "15 ans d'expérience",
      description: "Préparateur physique pour sportifs de haut niveau",
      image: "https://readdy.ai/api/search-image?query=Professional%20athletic%20trainer%20coaching%20client%20in%20functional%20fitness%20training%2C%20experienced%20sports%20performance%20coach%20demonstrating%20exercises%2C%20modern%20training%20facility%20with%20specialized%20equipment%2C%20focused%20and%20professional%20atmosphere&width=400&height=400&seq=coach-6&orientation=squarish"
    }
  ];

  const renderStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="ri-star-fill text-yellow-400"></i>);
    }
    
    if (hasHalfStar) {
      stars.push(<i key="half" className="ri-star-half-fill text-yellow-400"></i>);
    }
    
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="ri-star-line text-gray-300"></i>);
    }
    
    return stars;
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nos coachs les mieux notés
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez nos coachs sportifs les plus appréciés par nos clients. 
            Tous sont certifiés et passionnés par votre réussite.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {topCoaches.map((coach) => (
            <Card key={coach.id} className="hover:shadow-xl transition-shadow duration-300">
              <div className="text-center">
                <div className="relative mb-6">
                  <img
                    src={coach.image}
                    alt={coach.name}
                    className="w-24 h-24 rounded-full mx-auto object-cover border-4 border-blue-100"
                  />
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Top Coach
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-2">{coach.name}</h3>
                <p className="text-blue-600 font-medium mb-2">{coach.specialty}</p>
                <p className="text-gray-600 text-sm mb-4">{coach.description}</p>
                
                <div className="flex items-center justify-center mb-3">
                  <div className="flex mr-2">
                    {renderStars(coach.rating)}
                  </div>
                  <span className="text-gray-600 text-sm">
                    {coach.rating} ({coach.reviews} avis)
                  </span>
                </div>
                
                <div className="flex items-center justify-center text-gray-600 text-sm mb-2">
                  <i className="ri-map-pin-line mr-1"></i>
                  {coach.location}
                </div>
                
                <div className="flex items-center justify-center text-gray-600 text-sm mb-4">
                  <i className="ri-time-line mr-1"></i>
                  {coach.experience}
                </div>
                
                <div className="border-t pt-4">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-2xl font-bold text-gray-900">
                      {coach.price}€
                    </span>
                    <span className="text-gray-600 text-sm">/ séance</span>
                  </div>
                  
                  <div className="space-y-2">
                    <Button className="w-full" size="md">
                      Réserver une séance
                    </Button>
                    <Button variant="outline" className="w-full" size="md">
                      Voir le profil
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Button size="lg" variant="outline">
            Voir tous nos coachs
            <i className="ri-arrow-right-line ml-2"></i>
          </Button>
        </div>
      </div>
    </section>
  );
}
